import { Button, Result, Space } from "antd";
import { useDispatch, useSelector } from "react-redux";
import type { AppDispatch, RootState } from "../../store";
import { logoutUser } from "../../redux/services/customerService";
import { initiateLogin } from "../../utils/common";

const ErrorAppContent = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { permittedCustomersError } = useSelector((state: RootState) => state.userInfo);
    const signOut = () => {
        dispatch(logoutUser()).then(() => {
            initiateLogin();
        });
    };

    const handleRefresh = () => {
        window.location.reload();
    };

    return <div className="centerContainer">
        <Result
            title={
                ["Network Error", "Request failed with status code 500"].includes(permittedCustomersError)
                    ? `${permittedCustomersError} : Unable to reach the server.`
                    : "No permission has been added to your account. Please contact e-Boost admin."
            }
            status={
                ["Network Error", "Request failed with status code 500"].includes(permittedCustomersError)
                    ? "500"
                    : "warning"
            }
            extra={<Space>
                <Button type="primary" onClick={signOut}>Logout</Button>
                <Button type="primary" onClick={handleRefresh}>Refresh</Button>
            </Space>}
        />
    </div>
};
export default ErrorAppContent;